<template>
  <div class="page p-viewpoint-persona">
    <div class="page__head">
      <page-header :back-location="localePath({ name: 'viewpoint' })" title="page_persona.title" />
    </div>
    <div class="page__main page__main--fill">
      <persona-selector />
    </div>
  </div>
</template>

<script>
  import PageHeader from '@/components/page-header/page-header'
  import PersonaSelector from '@/components/persona-selector/persona-selector'

  export default {
    meta: {
      titleKey: 'meta.choose_persona.title',
    },
    components: { PersonaSelector, PageHeader },
  }
</script>
